import { DomainEvent } from "../model/domain-event.model";

export class AppDisconnectedEvent implements DomainEvent {
  readonly occurredAt = new Date();

  constructor() {}
}